import { OrderStatusV2 } from "/@/generated/graphql";

type StatusPresentation = { label: string; color: string };

const PRESENTATION_BY_STATUS: Record<OrderStatusV2, StatusPresentation> = {
  [OrderStatusV2.Draft]: { label: "Brouillon", color: "ink" },
  [OrderStatusV2.InProgress]: { label: "En cours", color: "brand" },
  [OrderStatusV2.AwaitingValidation]: {
    label: "À valider",
    color: "warning",
  },
  [OrderStatusV2.InDesign]: { label: "En design", color: "brand" },
  [OrderStatusV2.InProduction]: {
    label: "En production",
    color: "violet",
  },
  [OrderStatusV2.Shipped]: { label: "Expédiée", color: "emerald" },
  [OrderStatusV2.Delivered]: { label: "Livrée", color: "success" },
  [OrderStatusV2.ReturnRequested]: {
    label: "Retour demandé",
    color: "warning",
  },
};

// The use-cases types carry the status as its string value
export const getOrderStatusV2Presentation = (
  status: `${OrderStatusV2}`
): StatusPresentation => PRESENTATION_BY_STATUS[status as OrderStatusV2];

// « Mes commandes » lists no drafts: they are not offered as a filter
export const ORDER_STATUS_V2_FILTER_OPTIONS = Object.entries(
  PRESENTATION_BY_STATUS
)
  .filter(([value]) => value !== OrderStatusV2.Draft)
  .map(([value, { label }]) => ({ value, label }));
